
import { Component, Vue } from "vue-property-decorator";
import { copyToClipboard, Notify } from "quasar";
import axios from "axios";

interface dataBeneficio {
  id: number;
  nombre: string;
  descripcion: string;
  condiciones: string;
  descuento: number;
  cupo_max: number;
  fecha_termino: string;
  id_lector: number;
  tipo: number;
  tipo_vecino: number;
  usos_maximos: number;
  visible_app: number;
}

interface dataComercio {
  descripcion_corta: string;
  direccion: string;
  email: string;
  logo: string;
  foto: string;
  id: number;
  username: string;
  web: string;
  beneficios: Array<dataBeneficio>;
}
@Component({
  components: {},
  meta: {
    // sets document title
    title: "Tarjeta Pircana",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Conoce las novedades de Tarjeta Pircana."
      },
      keywords: { name: "keywords", content: "Pirque" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class Home extends Vue {
  private horizontalPercentageComercios = 0;
  private win = window;
  private base = window.location;
  private bannerSlide = "1";
  private horizontalPercentageInteres = 0;
  private nombreWeb: any = "";
  private nombreWebCategoria: any = "";
  private comercio: dataComercio = {
    descripcion_corta: "",
    direccion: "",
    email: "",
    logo: "",
    foto: "",
    id: 0,
    username: "",
    web: "",
    beneficios: []
  };
  private idLector: any = "";
  private beneficiosRelacionados: Array<any> = [];

  private mounted() {
    if (
      this.$router.currentRoute.params.nombre &&
      this.$router.currentRoute.params.nombre != ""
    ) {
      this.nombreWeb = this.$router.currentRoute.params.nombre;
      this.getInfoBeneficos();
      this.autoscrollComercios();
    }
  }

  private getInfoBeneficos() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("/listado/beneficio?nombre_web=" + this.nombreWeb)
      .then((res: any) => {
        this.comercio = res.data;
        this.nombreWebCategoria = res.data.nombreweb_categoria;
        this.beneficiosRelacionados = res.data.relacionados;
        let base = process.env.VUE_APP_BASE_URL;
        if (this.comercio.logo != null && this.comercio.logo) {
          this.comercio.logo = base + this.comercio.logo;
        } else {
          this.comercio.logo = require("@/assets/logos/logo-default.png");
        }
        if (this.comercio.foto != null && this.comercio.foto) {
          this.comercio.foto = base + this.comercio.foto;
        }
        for (let i = 0; i < this.beneficiosRelacionados.length; i++) {
          if (
            this.beneficiosRelacionados[i].logo != null &&
            this.beneficiosRelacionados[i].logo
          ) {
            this.beneficiosRelacionados[i].logo =
              base + this.beneficiosRelacionados[i].logo;
          } else {
            this.beneficiosRelacionados[
              i
            ].logo = require("@/assets/logos/logo-default.png");
          }
        }

        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
      });
  }

  private irBeneficio(idComercio: any, nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "Beneficio" &&
      this.$router.currentRoute.params.name == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "Beneficio",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
      this.$router.go(0);
    }
  }

  private irGoogleMaps(lat: any, lon: any) {
    window.open("https://www.google.com/maps/search/" + lat + "," + lon);
  }

  // private irWeb(data: any) {
  //   window.open(data);
  // }

  private irWeb(link) {
    if (link != "#") {
      window.open(link, "_blank");
    }
  }

  private irEmail(mail: string) {
    window.open("mailto:" + mail);
  }

  private llamar(data: any) {
    const numero = data;
    window.open("tel:" + numero);
  }

  private copiarClipboard(texto: any) {
    copyToClipboard(texto)
      .then(() => {
        Notify.create({
          color: "positive",
          message: "Se ha copiado el Número de Teléfono.",
          icon: "report_problem",
          position: "top",
          timeout: 2500
        });
        return;
      })
      .catch(() => {
        Notify.create({
          color: "negative",
          message: "Ha ocurrido un problema. Por favor, inténtelo de nuevo.",
          icon: "report_problem",
          position: "top",
          timeout: 2500
        });
        return;
      });
  }

  private formatFechaTermino(fecha_termino: any) {
    var anho_termino = fecha_termino.substring(0, 4);
    var mes_termino: any = parseInt(fecha_termino.substring(5, 7), 10);
    var dia_termino = fecha_termino.substring(8, 10);

    if (mes_termino == 1) {
      mes_termino = "ENERO";
    } else if (mes_termino == 2) {
      mes_termino = "FEBRERO";
    } else if (mes_termino == 3) {
      mes_termino = "MARZO";
    } else if (mes_termino == 4) {
      mes_termino = "ABRIL";
    } else if (mes_termino == 5) {
      mes_termino = "MAYO";
    } else if (mes_termino == 6) {
      mes_termino = "JUNIO";
    } else if (mes_termino == 7) {
      mes_termino = "JULIO";
    } else if (mes_termino == 8) {
      mes_termino = "AGOSTO";
    } else if (mes_termino == 9) {
      mes_termino = "SEPTIEMBRE";
    } else if (mes_termino == 10) {
      mes_termino = "OCTUBRE";
    } else if (mes_termino == 11) {
      mes_termino = "NOVIEMBRE";
    } else {
      mes_termino = "DICIEMBRE";
    }

    return dia_termino + " DE " + mes_termino + " DEL " + anho_termino;
  }

  private irCategoria(nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "Categorias" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "Comercios",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  private scrollAreaFunctionComercios(info: any) {
    this.horizontalPercentageComercios = info.horizontalPercentage;
  }

  private scroll(direccion: string) {
    if (this.$refs.scrollComercios as any) {
      const size = (this.$refs.scrollComercios as any).scroll.horizontal.size;
      const position = (this.$refs.scrollComercios as any).scroll.horizontal
        .position;
      if (direccion == "derecha") {
        if (this.horizontalPercentageComercios >= 1) {
          (this.$refs.scrollComercios as any).setScrollPosition(0, 120);
        } else {
          (this.$refs.scrollComercios as any).setScrollPosition(
            position + 220,
            120
          );
        }
      } else {
        if (position - 90 < 0) {
          if (position > 0) {
            (this.$refs.scrollComercios as any).setScrollPosition(0, 120);
          } else {
            (this.$refs.scrollComercios as any).setScrollPosition(size, 120);
          }
        } else {
          (this.$refs.scrollComercios as any).setScrollPosition(
            position - 90,
            120
          );
        }
      }
    }
  }
  private autoscrollComercios() {
    this.scroll("derecha");
    setTimeout(this.autoscrollComercios, 5000);
  }

  private toLink(link) {
    if (link != "#") {
      window.open(link, "_blank");
    }
  }
}
